import { GET_PH_COUNT, GET_PH_ID, GET_PH_LIST, GET_NUMBER_PH, ADD_ATTACHMENT_DIGISIGN_PH, DELETE_ATTACHMENT_DIGISIGN_PH, GET_NUMBER_OPERATOR_PH, DELETE_DATA_NOMOR, DELETE_DATA_DETAIL, GET_LIST_NUMBER_PH_BY_USER, GET_LIST_NUMBER_PH, GET_NUMBER_PH_DIRJEN } from 'shared/constants/ActionTypes';

const phList = {
    count: null,
    next: null,
    previous: null,
    results: []
};

const initialState = {
    phList: phList,
    phDetail: null,
    phCount: null,
    phGetNumber: null,
    phGetNumberOperator: null,
    phListNumberByUser: null,
    phListNumber: null,
    attachment: [],
}

const ProdukHukumReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PH_LIST:
            return {
                ...state,
                phList: action.payload
            }
        case GET_PH_ID:
            return {
                ...state,
                phDetail: action.payload
            }
        case GET_PH_COUNT:
            return {
                ...state,
                phCount: action.payload
            }
        case GET_NUMBER_PH:
            return {
                ...state,
                phGetNumber: action.payload
            }
        case GET_NUMBER_PH_DIRJEN:
            return {
                ...state,
                phGetNumber: action.payload
            }
        case ADD_ATTACHMENT_DIGISIGN_PH:
            return {
                ...state,
                attachment: [...state.attachment, action.payload],
            };
        case DELETE_ATTACHMENT_DIGISIGN_PH:
            return {
                ...state,
                attachment: action.payload,
            };
        case GET_NUMBER_OPERATOR_PH:
            return {
                ...state,
                phGetNumberOperator: action.payload,
            };
        case DELETE_DATA_NOMOR:
            return {
                ...state,
                phGetNumberOperator: action.payload,
            };
        case DELETE_DATA_DETAIL:
            return {
                ...state,
                phDetail: action.payload,
            };
        case GET_LIST_NUMBER_PH_BY_USER:
            return {
                ...state,
                phListNumberByUser: action.payload,
            };
        case GET_LIST_NUMBER_PH:
            return {
                ...state,
                phListNumber: action.payload,
            };
        default:
            return {
                ...state
            }
    }
};

export default ProdukHukumReducer